import styled, { css } from 'styled-components';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as IconButton } from '../Button/IconButton/IconButton-ByrRWZ-V.js';

// eslint-disable-next-line import/prefer-default-export
const CardHeaderStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1cwd7be-0"
})(["background:", ";display:flex;align-items:center;gap:", ";text-align:start;border:none;border-bottom:", ";border-radius:", ";", " ", ""], ({
  theme
}) => theme.surface.container.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme,
  $isCollapsed
}) => $isCollapsed ? 'none' : theme.border.subtle.default, ({
  theme,
  $isCollapsed
}) => $isCollapsed ? theme.border.radius.large : `${theme.border.radius.large} ${theme.border.radius.large} 0 0`, paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));
CardHeaderStyled.displayName = 'CardHeaderStyled';
const ExpandButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1cwd7be-1"
})(["&& svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", "}[dir=\"rtl\"] && svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}/*! @noflip */ transform:rotate(180deg);", "}"], ({
  $expanded
}) => $expanded && css(["/*! @noflip */ transform:rotate(90deg);"]), ({
  $expanded
}) => $expanded && css(["/*! @noflip */ transform:rotate(90deg);"]));

export { CardHeaderStyled as C, ExpandButton as E };
//# sourceMappingURL=CardHeader.styles-BXsaH2Jn.js.map
